export default __webpack_public_path__ + "static/media/camionetas.ab562a20.webp";